import { MenuItem, SelectChangeEvent } from '@mui/material';
import { StyledSelect, StyledFormLabel } from 'components/atoms';
import React, { useEffect, useState } from 'react';

import { SelectProps } from './types';

export const Select = ({
  disabled = false,
  initValue,
  label,
  onUpdate,
  options,
  selectStyle,
}: SelectProps) => {
  const [value, setValue] = useState(initValue);

  useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  const selectChange = (event: SelectChangeEvent<string>) => {
    const newValue = event.target.value as string;
    setValue(newValue);
    onUpdate(newValue);
  };
  return (
    <>
      {label ? <StyledFormLabel>{label}</StyledFormLabel> : null}
      <StyledSelect
        disabled={disabled}
        value={value}
        onChange={(event: any) => selectChange(event)}
        style={selectStyle}
      >
        {options.map((option) => (
          <MenuItem key={`option-${option.name}`} value={option.name}>
            {option.description}
          </MenuItem>
        ))}
      </StyledSelect>
    </>
  );
};
